import { render, staticRenderFns } from "./InvoiceMailButton.vue?vue&type=template&id=6f26fcb8&"
import script from "./InvoiceMailButton.vue?vue&type=script&lang=ts&"
export * from "./InvoiceMailButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports